var App = App || {};

// Factory that returns the Login module
App.Login = (function () {
    "use strict";

    var _isOpen,
        toggles = [],
        opener,
        panel;

    function init() {
        // Header toggles (main login button and utility bar button); the close button inside the panel is excluded
        toggles = Array.from(document.querySelectorAll('.btn-login, .login__toggle'));
        panel = document.getElementById("login-menu");

        toggles.forEach(function (toggle) {
            toggle.addEventListener('click', function (e) {
                // Prevent Bootstrap data-api from attempting to initialize an offcanvas
                // when the target element is not present in the DOM (which causes
                // bootstrap to throw trying to access parentNode/backdrop).
                var targetSelector = this.getAttribute('data-bs-target') || this.getAttribute('data-target') || this.getAttribute('href');
                if (targetSelector && !document.querySelector(targetSelector)) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    console.warn('Login toggle clicked but offcanvas target not found:', targetSelector);
                }
            });
        });

        if (panel) {
            panel.addEventListener('keydown', function (e) {
                // Tabbing forward past the last focusable element closes the panel
                if ((e.key === 'Tab' || e.keyCode === 9) && !e.shiftKey && document.activeElement === getLastFocusable()) {
                    e.preventDefault();
                    bootstrap.Offcanvas.getOrCreateInstance(panel).hide();
                }
            });
        }

        // Drive open/close state from the offcanvas itself so it applies however it was opened
        // (header toggle, a CTA link to #login-menu, or the URL hash on page load)
        const loginMenu = panel;
        if (loginMenu) {
            loginMenu.addEventListener('show.bs.offcanvas', function (e) {
                openLogin(e.relatedTarget);
            });

            loginMenu.addEventListener('shown.bs.offcanvas', function () {
                const firstInput = loginMenu.querySelector('input:not([type="hidden"]):enabled');
                if (firstInput) {
                    firstInput.focus();
                }
            });

            loginMenu.addEventListener('hidden.bs.offcanvas', function () {
                if (_isOpen) {
                    closeLogin();
                }
            });

            // Keep the panel fitted to the viewport through resizes and orientation changes
            let resizeTimeout;
            window.addEventListener('resize', function () {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function () {
                    if (_isOpen) {
                        positionPanel();
                    }
                }, 100);
            });
        }
    }

    // Below lg the panel opens under the header; size it to the remaining viewport height so it never
    // runs off the bottom of the screen (same approach as the mobile menu in SiteHeader.js)
    function positionPanel() {
        if (!panel) return;

        const bp = App.ZagBreakpoints.getBreakpoint();
        if (bp === 'xs' || bp === 'sm' || bp === 'md') {
            const siteHeader = document.getElementById("site-header");
            // the header isn't sticky, so once the page is scrolled it may be partly or fully off screen
            const topOffset = siteHeader ? Math.max(0, siteHeader.getBoundingClientRect().bottom) : 0;
            panel.style.top = topOffset + "px";
            panel.style.height = (window.innerHeight - topOffset) + "px";
        } else {
            panel.style.top = "";
            panel.style.height = "";
        }
    }

    function openLogin(relatedTarget) {
        opener = relatedTarget || null;

        setToggleState(true);
        positionPanel();

        _isOpen = true;
    }

    function closeLogin() {
        setToggleState(false);

        // Return focus to whatever opened the menu (header toggle or CTA link)
        if (opener && document.body.contains(opener)) {
            opener.focus();
        }

        opener = null;
        _isOpen = false;
    }

    function setToggleState(isOpen) {
        toggles.forEach(function (toggle) {
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            toggle.classList.toggle('login__toggle--open', isOpen);
        });
    }

    // Computed on demand so it reflects whichever elements are currently visible in the panel
    function getLastFocusable() {
        if (!panel) return null;
        const focusableElements = panel.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const visibleElements = Array.from(focusableElements).filter(el => {
            return el.offsetParent !== null && !el.disabled;
        });
        return visibleElements[visibleElements.length - 1] || null;
    }

    return {
        init: init,
        closeLogin: closeLogin,
        isOpen: function () { return _isOpen; }
    };
})();

document.addEventListener('DOMContentLoaded', function () {
    App.Login.init();
});
